_ = require("lodash")

MAX_TOTAL_SHOT = 200
MAX_TOTAL_PUTT = 5
PER_TOTAL_SHOT_DEFAULT = (72 * 100) / MAX_TOTAL_SHOT
PER_AVG_PUTT_DEFAULT = (2 * 100) / MAX_TOTAL_PUTT

BasicAnalysisService = ->
  ratioToPercent = (data) ->
    avg_total_shot: data?.avg_total_shot || []
    avg_putt: data?.avg_putt
    per_fairway_center:
      data?.rat_fairway_center * 100
    per_bogey_on:
      data?.rat_bogey_on * 100
    per_par_on:
      data?.rat_par_on * 100
    cnt_putt_disabled: data?.cnt_putt_disabled
    per_total_shot: do ->
      return PER_TOTAL_SHOT_DEFAULT unless data?.avg_total_shot
      _.min([data.avg_total_shot / MAX_TOTAL_SHOT, 1]) * 100
    per_avg_putt: do ->
      return PER_AVG_PUTT_DEFAULT unless data?.avg_putt
      _.min([data.avg_putt / MAX_TOTAL_PUTT, 1]) * 100

  parseDetailedAnalysisData: (data) ->
    requiredFields = [
      'avg_total_shot'
      'avg_putt'
      'rat_fairway_center'
      'rat_bogey_on'
      'rat_par_on'
      'cnt_putt_disabled'
    ]
    my_avg:
      _.pick data.my_avg, requiredFields
    goal:
      _.pick data.goal, requiredFields
    all_members:
      _.pick data.all_members, requiredFields

  createViewModel: (data) ->
    _.mapValues data, (val) -> ratioToPercent(val)

BasicAnalysisService.$inject = [
  'NumberService'
]

module.exports = BasicAnalysisService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/basic-analysis/basic-analysis-service.coffee